export const LIVE_MODE_MOVEMENT = 'LIVE_MODE_MOVEMENT';
export const LIVE_MODE_ENERGY_MONITORING = 'LIVE_MODE_ENERGY_MONITORING';
export const LIVE_MODE_LAMP_NAMES = 'LIVE_MODE_LAMP_NAMES';

export const LIVE_TOTAL_ELECTRIC_CURRENT = 'all_ec';
export const LIVE_MAX_ELECTRIC_CURRENT = 'max_ec';

export const LIVE_TOTAL_POWER = 'all_pwr';
export const LIVE_MAX_POWER = 'max_pwr';
